export function useEventDate() {
  const { translate } = useTranslations()
  const localization = useBaseLocalization()
  const currentLanguage = computed(() => localization.getCurrentLanguage())

  const locale = computed(() => {
    return currentLanguage.value.name === 'nl' ? 'nl-NL' : 'en-EN'
  })

  function getEventItemDate(eventContent: any) {
    if (!eventContent.programs) return

    if (!eventContent.programs || eventContent.programs.length === 0) {
      return ''
    }

    if (eventContent.programs.length > 1) {
      return translate('Meerdere data en tijden')
    } else if (eventContent.programs.length === 1) {
      const dateObj = new Date(eventContent.programs[0].startAt)
      const weekday = dateObj.toLocaleDateString(locale.value, { weekday: 'short' })
      const day = dateObj.getDate().toString().padStart(2, '0')
      const month = dateObj.toLocaleDateString(locale.value, { month: 'short' }).replace('.', '')
      const time = dateObj.toLocaleTimeString(locale.value, { hour: '2-digit', minute: '2-digit' })
      return `${weekday} ${day} ${month} - ${time}`
    }
  }

  return {
    getEventItemDate,
  }
}
